// extracted by mini-css-extract-plugin
export default {"modal":"ModalComponent_modal__JNX2u","modalWrapper":"ModalComponent_modalWrapper__Tryek","button":"ModalComponent_button__632Vq","title":"ModalComponent_title__OPcuR"};